import { Listbox, Transition } from "@headlessui/react";
import cadviewer from "cadviewer";
import {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import { CadviewerContext } from "../../context/Cadviewer.Context";
import useConfig from "../../demos/hooks/useConfig";
import { View } from "../../types";
import {
  CADViewerHelperMethods,
  DisabledClickWrapper,
  RightAction,
  Tooltip,
} from "../index";
import { getAllDemos } from "../../demos";
import { useDeepLinkView } from "../../hooks/useDeepLinkView";
import EventSystem from "../../events/EventSystem";

interface HeaderProps {
  leftPanelOpen: boolean;
  setLeftPanelOpen: any;
}

const Header = ({ leftPanelOpen, setLeftPanelOpen }: HeaderProps) => {
  const location = useLocation();
  const { config } = useConfig();
  const [selectedLayer, setSelectedLayer] = useState<View | null>(null);

  if (config.debugMode) console.log("Header component - config:", config.displayTopPaneScrollDownButton);

  const {
    selectedPlan,
    selectedPlanDetail,
    plansInfo,
    views,
    currentPlanType,
    setLayerColorsOnLoad,
    layerColorsOnLoad,
    setCurrentDrawingPath,
    currentCanvasInstance,
    setSelectedSpaceObjectID,
    setSelectedPlanDetail,
    disableFeature,
    querySelectedView,
    signalDrawingLoadStart,
  } = useContext(CadviewerContext);

  if (config.debugMode) console.log({ layerColorsOnLoad });

  const cvjs_brookfield_layerchange = useCallback((layer: View) => {
    if (config.debugMode) console.log("layerchange: " + layer.initialLayerState);

    if (layer.view === "Choose information plan/layer") {
      return;
    }

    if (config.debugMode) {
      if (config.debugMode) console.log("Header.component - AllLayersOFF:" + layer.initialLayerState);
    }

    setLayerColorsOnLoad(
      layer.layers.map((layer) => ({
        layer: layer.layer,
        color:
          layer.colorOverride === undefined || layer.colorOverride === "none"
            ? "originalColor"
            : layer.colorOverride,
      }))
    );

    /*
        // 10.43.1
        console.log("Header.component-tsx - cvjs_colorSingleLayer:  number of layers:"+layerColorsOnLoad.length);

        for (var i=0; i< layerColorsOnLoad.length; i++){
            var thislayer = layerColorsOnLoad[i];
//            cadviewer.cvjs_colorSingleLayer(currentCanvasInstance ?? "floorPlan", thislayer.color, thislayer.layer);
            cadviewer.cvjs_colorSingleLayer(currentCanvasInstance ?? "floorPlan", thislayer.color, thislayer.layer);

        }
*/

    if (layer.initialLayerState === "AllOff") {
      // optimization test
      //            cadviewer.cvjs_AllLayersOff(currentCanvasInstance ?? "floorPlan")

      try {
        if (config.debugMode) console.log("1");

        let layerTable = cadviewer.cvjs_getLayerTable(
          currentCanvasInstance ?? "floorPlan"
        );
        let newLayerTable = [];
        if (config.debugMode) console.log("2");
        for (let i = 0; i < layerTable.numberOfLayers; i++) {
          if (config.debugMode)
            if (config.debugMode) console.log(i + " " + layerTable.layers[i].layerName);
          newLayerTable[i] = {
            name: layerTable.layers[i].layerName,
            newStatus: "OFF",
          };
        }

        if (config.debugMode) console.log(
          "Header component - AllOff - layerchange, number of layers: " +
          layer.layers.length
        );

        if (layer.layers.length >= 1) {
          // get the list of all layers:

          for (let index = 0; index < layer.layers.length; index++) {
            const element = layer.layers[index];
            if (element.layerState === "On") {
              if (config.debugMode) console.log(
                index + " layer on:" + element.layer + " " + element.layerState
              );
              for (let i = 0; i < newLayerTable.length; i++) {
                if (newLayerTable[i].name === element.layer)
                  newLayerTable[i].newStatus = "ON";
              }

              cadviewer.cvjs_LayerOn(element.layer);
            } else if (element.layerState === "Off") {
              cadviewer.cvjs_LayerOff(element.layer);
              if (config.debugMode) console.log(
                index + " layer off:" + element.layer + " " + element.layerState
              );
            }

            try {
              // 10.43.8               // do  we only need this for on layers?
              var elementcolor =
                element.colorOverride === undefined ||
                  element.colorOverride === "none"
                  ? "originalColor"
                  : element.colorOverride;
              if (config.debugMode) console.log("Header loop:" + elementcolor + " " + element.layer);
              cadviewer.cvjs_colorSingleLayer(
                currentCanvasInstance ?? "floorPlan",
                elementcolor,
                element.layer
              );
            } catch (err_color) {
              if (config.debugMode) console.log("Header component color error: " + err_color);
            }
          }

          // turn off all layers that are not in the list
          for (let i = 0; i < newLayerTable.length; i++) {
            //console.log("layerTable.layers[i].layerName:"+layerTable.layers[i].layerName+" status:"+layerTable.layers[i].status);
            if (newLayerTable[i].newStatus === "OFF")
              cadviewer.cvjs_LayerOff(newLayerTable[i].name);
          }
        }
      } catch (err) {
        if (config.debugMode) console.log("Header component AllOff error: " + err);
      }
    } else if (layer.initialLayerState === "AllOn") {
      cadviewer.cvjs_AllLayersOn(currentCanvasInstance ?? "floorPlan");

      if (config.debugMode) console.log(
        "AllOn - Header component layerchange, number of layers: " +
        layer.layers.length
      );

      if (layer.layers.length >= 1) {
        for (let index = 0; index < layer.layers.length; index++) {
          const element = layer.layers[index];
          if (element.layerState === "On") {
            if (config.debugMode) console.log("layer on:" + element.layer + " layerState:" + element.layerState);

            cadviewer.cvjs_LayerOn(element.layer);
          } else if (element.layerState === "Off") {
            cadviewer.cvjs_LayerOff(element.layer);
            if (config.debugMode) console.log("layer off:" + element.layer + " layerState:" + element.layerState);
          }
        }
      }
    }


    // 11.14.5  - we do not set any space objects 
    /*

  if (config.enableHelpersMethodsGroup_UrbanEdge != undefined && config.enableHelpersMethodsGroup_UrbanEdge == true) {
    // for UrbanEdge, we need to control the image layers

  }
  else {
    // standard legacy execution
    // CH  -we need all SpaceObject turned on
    // cadviewer.cvjs_allSpaceObjectsOn(currentCanvasInstance ?? "floorPlan");
  }
*/




    try {
      // 10.40.1
      if (config.setZoomImageWallpaper) {
        if (config.debugMode) console.log("cvjs_activateZoomImageWallpaper 1");
        cadviewer.cvjs_activateZoomImageWallpaper();
      }
    } catch (err) {
      if (config.debugMode) console.log("Header component setZoomImageWallpaper error: " + err);
    }

    return;
  }, [config, currentCanvasInstance, setLayerColorsOnLoad]);

  const handleSelectedLayer = useCallback((layer: View) => {
    const viewName = layer?.view || layer?.View || "unknown";
    console.log(`[DeepLink] handleSelectedLayer() — applying layer "${viewName}", setBPLayerChange=${config.setBPLayerChange}`);
    // 10.55.2
    if (config.setBPLayerChange) {
      console.log(`[DeepLink] handleSelectedLayer() — calling layerchange("${viewName}")`);
      cvjs_brookfield_layerchange(layer); //DEBUG
    }
    //cvjs_brookfield_layerchange(layer); //DEBUG
    setSelectedLayer(layer);
    console.log(`[DeepLink] handleSelectedLayer() — setSelectedLayer done for "${viewName}"`);
  }, [cvjs_brookfield_layerchange, config.setBPLayerChange, setSelectedLayer]);


  const demosPathnames = getAllDemos().map((demo) => demo.route);

  const isHome = useMemo(
    () =>
      location.pathname === "" ||
      location.pathname === "/" ||
      demosPathnames.includes(location.pathname),
    [location.pathname, demosPathnames]
  );


  /*
    const isHome = useMemo(
      () => location.pathname === "" || location.pathname === "/",
      [location.pathname]
    );
  */



  // Effective target view: URL deep link takes priority, then config planView
  const targetViewName = querySelectedView || config.defautlPropertyToLoad?.planView || null;

  // Currently selected view name (to maintain across plan changes)
  const currentSelectedViewName = selectedLayer?.view || selectedLayer?.View || null;

  //console.log(`[DeepLink] Header render — targetViewName="${targetViewName}", currentSelectedViewName="${currentSelectedViewName}", isHome=${isHome}, querySelectedView="${querySelectedView}", configPlanView="${config.defautlPropertyToLoad?.planView}"`);

  // === SYNCHRONOUS deep link view application via EventSystem ===
  // This subscriber fires SYNCHRONOUSLY inside cvjs_OnLoadEnd (before React effects),
  // applying layer changes immediately while the SVG DOM is freshly loaded.
  const viewsRef = useRef(views);
  const currentPlanTypeRef = useRef(currentPlanType);
  const targetViewNameRef = useRef(targetViewName);
  const currentSelectedViewNameRef = useRef(currentSelectedViewName);
  const handleSelectedLayerRef = useRef(handleSelectedLayer);
  const syncInitialLoadDoneRef = useRef(false);
  // Track whether sync subscriber already applied view this load cycle (shared with useDeepLinkView)
  const syncViewAppliedRef = useRef(false);

  // Keep refs up-to-date
  useEffect(() => { viewsRef.current = views; }, [views]);
  useEffect(() => { currentPlanTypeRef.current = currentPlanType; }, [currentPlanType]);
  useEffect(() => { targetViewNameRef.current = targetViewName; }, [targetViewName]);
  useEffect(() => { currentSelectedViewNameRef.current = currentSelectedViewName; }, [currentSelectedViewName]);
  useEffect(() => { handleSelectedLayerRef.current = handleSelectedLayer; }, [handleSelectedLayer]);

  useEffect(() => {
    const onLoadEndSync = () => {
      const v = viewsRef.current;
      const pt = currentPlanTypeRef.current;
      const tvn = targetViewNameRef.current;
      const csvn = currentSelectedViewNameRef.current;

      console.log(`[DeepLink][SYNC] onLoadEnd subscriber — views=${v.length}, planType="${pt}", targetView="${tvn}", currentView="${csvn}"`);

      if (!pt || v.length === 0) {
        console.log("[DeepLink][SYNC] SKIP: planType or views not ready");
        return;
      }

      const viewList = v.find((vp) => vp.planType === pt)?.views ?? [];
      if (viewList.length === 0) {
        console.log(`[DeepLink][SYNC] SKIP: no views for planType="${pt}"`);
        return;
      }

      let viewToApply: View | undefined;

      // Priority 1: First load with target view (deep link or config planView)
      if (!syncInitialLoadDoneRef.current && tvn) {
        viewToApply = viewList.find((vw) => (vw.view || vw.View) === tvn);
        console.log(`[DeepLink][SYNC] First load: target "${tvn}" → ${viewToApply ? "found" : "not found"}`);
      }

      // Priority 2: Subsequent loads — maintain current selection
      if (!viewToApply && syncInitialLoadDoneRef.current && csvn) {
        viewToApply = viewList.find((vw) => (vw.view || vw.View) === csvn);
        console.log(`[DeepLink][SYNC] Plan change: current "${csvn}" → ${viewToApply ? "found" : "not found"}`);
      }

      // Priority 3: Fallback to target
      if (!viewToApply && tvn) {
        viewToApply = viewList.find((vw) => (vw.view || vw.View) === tvn);
        console.log(`[DeepLink][SYNC] Fallback target "${tvn}" → ${viewToApply ? "found" : "not found"}`);
      }

      // Priority 4: Default view
      if (!viewToApply) {
        viewToApply = viewList.find((vw) => vw.selected) ?? viewList[0];
        console.log(`[DeepLink][SYNC] Fallback default → "${viewToApply?.view || viewToApply?.View}"`);
      }

      if (viewToApply) {
        console.log(`[DeepLink][SYNC] Applying view SYNCHRONOUSLY: "${viewToApply.view || viewToApply.View}"`);
        handleSelectedLayerRef.current(viewToApply);
        syncInitialLoadDoneRef.current = true;
        syncViewAppliedRef.current = true;
      }
    };

    EventSystem.subscribe("cadviewer.cvjs_onLoadEnd", onLoadEndSync);
    console.log("[DeepLink][SYNC] Subscribed to cadviewer.cvjs_onLoadEnd");

    return () => {
      EventSystem.unsubscribe("cadviewer.cvjs_onLoadEnd", onLoadEndSync);
      console.log("[DeepLink][SYNC] Unsubscribed from cadviewer.cvjs_onLoadEnd");
    };
  }, []); // Empty deps — uses refs for all data access

  // Centralized hook handles target view, default view, AND plan change view reactively (fallback)
  useDeepLinkView(handleSelectedLayer, isHome, targetViewName, currentSelectedViewName, syncViewAppliedRef);

  let { propertySVGFilesLocation } = config;

  return (
    <div className="bg-gray-100 min-h-20 px-4 md:px-6 lg:px-14 py-2">
      <div className="w-full flex flex-wrap flex-col lg:flex-row justify-between items-stretch gap-2">
        <div className="flex flex-row gap-2 items-center">
          {isHome && !config.hideLeftHamburgerMenu && (
            <Tooltip text={config.hambugerMenuTooltip}>
              <button
                id="hamburger-menu"
                className="-ml-4 md:-ml-6 lg:-ml-14 mr-2 md:mr-5 bg-sidebar-hamburger-background text-sidebar-hamburger-icon p-2 lg:p-3"
                onClick={() => setLeftPanelOpen((state: boolean) => !state)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
              </button>
            </Tooltip>
          )}
          {config.topBarLogo && (
            <img
              src={config.topBarLogo}
              alt="CADViewer Logo"
              className="h-9 sm:h-11 mr-2"
            />
          )}
          {leftPanelOpen ? (
            <img
              src={"/CADViewer_Submark.svg"}
              alt="CADViewer Logo"
              className={`h-9 sm:h-10 ${!leftPanelOpen || !config.topBarLogo ? "block" : "hidden"
                }`}
            />
          ) : (
            <img
              src={"/CADViewer_Primary_logo.svg"}
              alt="CADViewer Logo"
              className={`h-9 sm:h-10 ${!leftPanelOpen || !config.topBarLogo ? "block" : "hidden"
                }`}
            />
          )}
        </div>
        {/* Group Logo and Main Info */}
        <div className="flex flex-wrap items-center lg:ml-4 min-w-0">
          <div className="flex flex-col justify-start items-start lg:ml-4 flex-1 min-w-0">
            <div>
              <h4>
                <b>
                  {!selectedPlanDetail ? (
                    config.AppName
                  ) : (
                    <span className={`block truncate font-medium`}>
                      {config.topRowItem1} {plansInfo?.["propertyName"]}
                      <span className="ml-2 sm:ml-4">
                        {config.topRowItem2} {plansInfo?.["propertyNumber"]}{" "}
                      </span>
                      <span className="ml-2 sm:ml-4">
                        {config.topRowItem3}{" "}
                        <DisabledClickWrapper>
                          <select
                            className="bg-white rounded-lg px-2 py-1 text-sm focus:outline-none focus:ring-0"
                            value={
                              selectedPlanDetail?.["planName"] || undefined
                            }
                            onChange={(e) => {
                              const currentSelectedPlan =
                                selectedPlan?.plans.find(
                                  (plan) => plan.planName === e.target.value
                                );
                              if (!currentSelectedPlan) return;
                              const svgFileLink = (
                                propertySVGFilesLocation +
                                currentSelectedPlan?.svgFileName
                              ).replace("/v2/svg/retail/", "/svg/");

                              // 10.71.1
                              cadviewer.cvjs_hideOnlyPop();
                              // 10.44.3

                              cadviewer.cvjs_ClearDrawing("floorPlan");

                              cadviewer.cvjs_setZoomImageWallpaper(false); // 10.30.2

                              console.log("[DeepLink] Header plan change — signalDrawingLoadStart()");
                              signalDrawingLoadStart();
                              // 10.36.6 - we block off here
                              cadviewer.cvjs_LoadDrawing(
                                "floorPlan",
                                svgFileLink
                              );

                              setCurrentDrawingPath(svgFileLink);
                              setSelectedPlanDetail(currentSelectedPlan);
                              setSelectedSpaceObjectID(undefined);

                              console.log("Plan sélectionné:", e.target.value);
                            }}
                            disabled={disableFeature}
                          >
                            {selectedPlan?.plans.map((plan) => (
                              <option value={plan.planName}>
                                {plan.planName}
                              </option>
                            ))}
                          </select>
                        </DisabledClickWrapper>
                      </span>
                    </span>
                  )}
                </b>
                {config.ContactEmailsFlag && (
                  <span className="ml-0 sm:ml-4 block">
                    Contact us at:{" "}
                    {config.ContactEmails.map((email: any, index: number) => (
                      <>
                        <a
                          href={"mailto:" + email}
                          key={email}
                          className="text-blue-500 text-decoration-underline"
                        >
                          {email}
                        </a>
                        {index === config.ContactEmails.length - 1
                          ? ""
                          : " or "}
                      </>
                    ))}{" "}
                  </span>
                )}
              </h4>
            </div>

            {config.displayTopPaneScrollDownButton &&
              isHome /* ENABLE switch  config.displayTopPaneScrollDownButton  , if false this part is omitted*/ && (
                <div className="flex justify-start flex-col sm:flex-row items-start sm:items-center w-full mt-1">
                  {" "}
                  {/* Todo put on the same ligne when ther's space Choose information plan/layer: */}
                  <b className="block text-sm text-nowrap mr-2">
                    {config.topPaneScrollDownTitle}
                  </b>
                  <div>
                    <DisabledClickWrapper>
                      <Listbox
                        value={selectedLayer}
                        onChange={handleSelectedLayer}
                        disabled={disableFeature}
                      >
                        <div className="relative mt-1">
                          <Listbox.Button
                            style={{ width: config.layerOptionWidth }}
                            className="max-w-80 relative cursor-pointer rounded-lg bg-white py-1 pl-3 pr-10 text-left focus:outline-none focus-visible:border-primary-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-300 sm:text-sm"
                          >
                            <span className="block truncate">
                              {selectedLayer?.view ||
                                selectedLayer?.View ||
                                "No Selection - Please select a View"}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                          <Transition
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                            afterEnter={() => {
                              if (config.setZoomImageWallpaper)
                                cadviewer.cvjs_deactivateZoomImageWallpaper();
                            }}
                            afterLeave={() => {
                              if (config.setZoomImageWallpaper)
                                cadviewer.cvjs_reactivateZoomImageWallpaper();
                            }}
                          >
                            <Listbox.Options className="absolute z-50 mt-0 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                              {[
                                ...(views.find(
                                  (viewPlan) =>
                                    viewPlan.planType === currentPlanType
                                )?.views ?? []),
                              ].map((layer, layerIdx) => (
                                <Listbox.Option
                                  key={layerIdx}
                                  className={({ active }) =>
                                    `relative cursor-pointer select-none py-2 pl-10 pr-4 ${active
                                      ? "bg-primary-100 text-primary-900"
                                      : "text-gray-900 cursor-pointer"
                                    }`
                                  }
                                  value={layer}
                                >
                                  {({ selected }) => (
                                    <>
                                      <span
                                        className={`block truncate ${selected
                                          ? "font-medium"
                                          : "font-normal"
                                          }`}
                                      >
                                        {layer.view || layer.View}
                                      </span>
                                      {selected ? (
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-primary-600">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-5 h-5"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              d="M4.5 12.75l6 6 9-13.5"
                                            />
                                          </svg>
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </Listbox>
                    </DisabledClickWrapper>
                  </div>
                </div>
              )}
          </div>
        </div>
        <RightAction />
      </div>

      {isHome && config.enableHelperMethods && <CADViewerHelperMethods />}
    </div>
  );
};

export default Header;
